import requester from '@/lib/axios';
import { TextQuestion, TextQuestionDTO } from '@/models/Question';

const baseUrl = 'text-activity';

export const getTextQuestion = async (id: number) => {
  const { data: textActivity } = await requester().get<TextQuestion>(
    `${baseUrl}/${id}/`,
  );

  return textActivity;
};

export const updateTextQuestion = async (
  id: number,
  changes: TextQuestionDTO,
) => {
  const { data: textActivity } = await requester().patch<TextQuestion>(
    `${baseUrl}/${id}/`,
    changes,
  );

  return textActivity;
};

export const deleteTextQuestion = async (id: number) => {
  await requester().delete<TextQuestion>(`${baseUrl}/${id}/`);
};

export const createTextQuestion = async (body: TextQuestionDTO) => {
  const { data: textQuestion } = await requester().post<TextQuestion>(
    `${baseUrl}/`,
    body,
  );

  return textQuestion;
};
